import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-share",
  "use": "foquz-icon-share-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-share\"><g clip-path=\"url(#foquz-icon-share_clip0_4854_11944)\"><path d=\"M11 4H5.9S1 4 1 9c0 3.9 3 8 3 8s-1.7-7 1.8-7H11v3l6-6-6-6v3z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /></g><defs><clipPath id=\"foquz-icon-share_clip0_4854_11944\"><path fill=\"#fff\" d=\"M0 0h18v18H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol